export const LOAD_MNG_CANDIDATE_CV = 'load_mng_candidate_cv';
export const MNG_CANDIDATE_CV_FAILED = 'loading_mng_candidate_cv_has_failed';
export const MNG_CANDIDATE_CV_LOADED = 'set_loaded_mng_candidate_cv';
export const LOAD_MNG_CV = 'load_mng_cv';
export const MNG_CV_FAILED = 'loading_mng_cv_has_failed';
export const MNG_CV_LOADED = 'set_loaded_mng_cv';
export const RESET_SYNCING = 'candidate_reset_syncing';
